<div class="ui-g-12 p-0">
  <div class="ui-g-12 p-0 vechicle-item" id="V{{ vehicle._id }}">
    <!-- Accordion header and button -->
    <div class="ui-g-12 p-0 vehicle-accordion"
      [attr.data-toggle]="highLightedVehicleId === vehicle._id? 'expand': 'collapse'"
      [attr.data-target]="'#veh'+vehicle._id" [attr.aria-expanded]="highLightedVehicleId === vehicle._id"
      [attr.aria-controls]="'veh'+vehicle._id">
      <div class="ui-g-12 py-1 px-2 flex-between-center">
        <div class="side-vehicle-name">
          <i class="fal fa-chevron-down fa-fw accordion-icon"></i>
          <p class="font-16 font-600 m-0">
            {{ vehicle.vehicleName || vehicle.name }}
          </p>
          <div class="lic-platnumber-wrapper" *ngIf="vehicle.licensePlateNo">{{ vehicle.licensePlateNo }}</div>
        </div>

        <div class="flex-end-center ml-2 vehilce-modal-pill" (click)="$event.stopPropagation()">
          <div>
            <app-switch-pill id="vehicle-update-isactive{{index}}" [isActive]="vehicle?.isActive"
              [label]="vehicle?.isActive ? 'Active' : 'Inactive'" position="end" [fontSize]="12"
              (appChange)="handleChange('isActive', $event)" [disabled]="isValidTransferActive()"
              [tooltipText]="isValidTransferActive() && 'Vehicle cannot be made active because this customer is not the current vehicle owner'"
              [tooltipPosition]="isValidTransferActive() && 'right'"></app-switch-pill>
          </div>

          <ng-container *ngIf="isMotorLookupEnabled">
            <ng-container *ngIf="!vehicle?.isMotorConnected && !(customer?.isFleetCustomer && isMyFleetCenterEnabled)">
              <span class="pt-2 pb-2 pl-2 pr-0 pointer" *ngIf="!vehicle?.isMotorAndCarfaxSynced; else motorLinking"
                (click)="vehicle?.isActive && openChooseVehicleDialog(false)">
                <i class="far fa-unlink vehicle-unlink font-red" [ngClass]="{ 'not-allowed': !isVehicleInActive() }"
                  tooltipPosition="top" pTooltip="Connect to Motor"
                  tooltipStyleClass="motor-vehicle-link-tooltip font-11"></i>
              </span>

              <ng-template #motorLinking>
                <span class="py-2 px-1 pointer" (click)="isVehicleInActive() && showVehicleSearchField()">
                  <i class="far fa-unlink vehicle-unlink" [ngClass]="{ 'not-allowed': !isVehicleInActive() }"
                    tooltipPosition="top" pTooltip="Connect to Motor"
                    tooltipStyleClass="motor-vehicle-link-tooltip font-11"></i>
                </span>
              </ng-template>
            </ng-container>

            <span *ngIf="vehicle?.isMotorConnected && !(customer?.isFleetCustomer && isMyFleetCenterEnabled)"
              class="pt-2 pb-2 pr-0 pointer motor-linked-option">
              <app-dropdown field="label" itemWidth="120px" hPosition="left" scrollHeight="150px"
                [listItemFontSize]="14" [options]="motorLinkedOptions" [isDropdownIconVisible]="false"
                [hasCustomOpenTemplate]="true" [disabled]="!isVehicleInActive()"
                (appSelect)="handleMotorOptionSelect($event)">
                <ng-template let-header appTemplate="open-dropdown-btn">
                  <i class="far fa-link vehicle-link" tooltipPosition="top"
                    tooltipStyleClass="motor-vehicle-link-tooltip font-11" [pTooltip]="tooltip"></i>
                </ng-template>
              </app-dropdown>
            </span>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Accordion body -->
    <div id="veh{{vehicle._id}}" class="{{highLightedVehicleId === vehicle._id? 'expand': 'collapse'}} ui-g-12 p-0"
      [attr.aria-labelledby]="vehicle._id">
      <!-- Vehicle Search -->
      <div *ngIf="isCompatibilityBannerVisible" class="alert alert-danger flex-start-center m-1 mr-2 ml-2">
        <i class="fal fa-exclamation-triangle mr-3"></i>
        <p class="m-0">
          Due to compliance, these fields are now mandatory. Please update the missing information when possible
        </p>
      </div>

      <div class="d-flex fleet-motor-button-section" *ngIf="customer?.isFleetCustomer && isMyFleetCenterEnabled">
        <button class="btn-fleet-motor bg-fleet-center d-flex align-items-center"
          [ngClass]="{ 'not-allowed': !isVehicleInActive() }" [disabled]="!isVehicleInActive()"
          (click)="onChangeFleetConnection()" *ngIf="customer?.isMFCustomer && !vehicle.isMFConnected">
          <img src="assets/myFleetCenterIntegration-icon.svg" />
          Connect to MyFleetCenter
        </button>
        <div class="dropdown-section" *ngIf="customer?.isMFCustomer && vehicle.isMFConnected">
          <app-content-overlay [dropshadow]="false" [showArrow]="false" showOnClick="true"
            [disabled]="!isVehicleInActive()" [closeAfterAction]="closeAfterAction" right="0" width="100%" top="35px">
            <ng-template appTemplate="item">
              <div class="btn-fleet-motor bg-fleet-center d-flex align-items-center mt-0"
                [ngClass]="{ 'not-allowed': !isVehicleInActive() }">
                <div class="icon">
                  <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1" />
                  Connected
                </div>
                |
                <div class="filter-cross">
                  <i class="fal fa-chevron-down width-10px" *ngIf="!isDropdownOpen"></i>
                </div>
              </div>
            </ng-template>
            <ng-template appTemplate="overlay">
              <div class="filter-overlay w-148px">
                <div class="filter-option" (click)="onChangeFleetConnection()">
                  Update vehicle
                </div>
                <div class="filter-option bg-filter-option" (click)="onChangeFleetConnection('disconnect')">
                  Disconnect
                </div>
              </div>
            </ng-template>
          </app-content-overlay>
        </div>

        <ng-container *ngIf="isMotorLookupEnabled">
          <div class="motor-dropDown-padding" *ngIf="vehicle?.isMotorConnected">
            <app-dropdown field="label" hPosition="left" [options]="motorLinkedOptions" [isDropdownIconVisible]="false"
              styleClass="motor-dropDown-padding" [hasCustomOpenTemplate]="true" [disabled]="!isVehicleInActive()"
              (appSelect)="handleMotorOptionSelect($event)">
              <ng-template let-header appTemplate="open-dropdown-btn">
                <button class="btn-fleet-motor bg-motor-center d-flex align-items-center ml-2"
                  [ngClass]="{ 'not-allowed': !isVehicleInActive() }" (click)="openVehicleInSidepanel($event, true)">
                  <img src="assets/motor-icon.png" />
                  Connected |
                  <div class="filter-cross">
                    <i class="fal fa-chevron-down width-10px"></i>
                  </div>
                </button>
              </ng-template>
            </app-dropdown>
          </div>

          <div class="motor-dropDown-padding dropdown-section">
            <app-content-overlay [dropshadow]="false" [showArrow]="false" showOnClick="true"
              [disabled]="!isVehicleInActive()" [closeAfterAction]="closeAfterAction" right="0" width="100%" top="35px">
              <ng-template appTemplate="item">
                <button *ngIf="!vehicle?.isMotorAndCarfaxSynced && !vehicle?.isMotorConnected; else motorLinking"
                  class="btn-fleet-motor bg-motor-center d-flex align-items-center ml-2"
                  [disabled]="!isVehicleInActive()" (click)="vehicle?.isActive && openChooseVehicleDialog(false)"
                  [ngClass]="{ 'not-allowed': !isVehicleInActive() }">
                  <img src="assets/motor-icon.png" />
                  Connect to MOTOR
                </button>
              </ng-template>

              <ng-template #motorLinking>
                <button *ngIf="!vehicle?.isMotorConnected"
                  class="btn-fleet-motor bg-motor-center d-flex align-items-center ml-2"
                  [disabled]="!isVehicleInActive()" (click)="isVehicleInActive() && showVehicleSearchField()"
                  [ngClass]="{ 'not-allowed': !isVehicleInActive() }">
                  <img src="assets/motor-icon.png" />
                  Connect to MOTOR
                </button>
              </ng-template>
            </app-content-overlay>
          </div>
        </ng-container>
      </div>

      <div class="ui-g-12 p-0 pl-4 pr-4 mt-4 sidepanel-vehicle-motor-search position-relative"
        *ngIf="isSearchFieldVisible">
        <app-auto-complete theme="primary" label="Search vehicle" noRecordIcon="fal fa-car font-16 pr-2"
          scrollHeight="310px" leftIcon="far fa-search" noRecordText="No vehicle match your search"
          inactiveItemsKey="htmlName" listItemFontSize="14" itemWidth="500px" [placeholder]="vehicleSearchPlaceholder"
          [textTruncate]="true" [delay]="1000" [fontSize]="14" [autoFocus]="focus?.search" [selectInactiveItems]="false"
          [suggestions]="vehicleSuggestions" [floatingLabel]="true" [value]="vehicleQuery"
          [isLoading]="isSearchingVehicle" (appSelect)="onVehicleSelect($event)" (appBlur)="handleBlur('search')"
          (appEscPress)="handleCloseVehicleSearch()" (appCompletedMethod)="onSearchVehicle($event, 'fromSearchInput')">
          <ng-template let-item let-idx="index" let-close="close" appTemplate="item">
            <div class="width-100p p-2 font-14 b-bottom" [hidden]="!item?.isHeader || !vehicle?.registrationState"
              (click)="handleOpenStateDropdown(close)">
              <div class="flex-start-center font-14 text-truncate">
                Registration&nbsp;state:
                <span class="font-600 font-primary pl-2 text-truncate">
                  {{ vehicle?.registrationState }}
                </span>
              </div>
            </div>

            <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
              <div class="flex-between-center">
                <p class="m-0" [innerHTML]="item?.htmlName"></p>
                <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                  [innerHTML]="item?.htmlLicensePlate"></p>
              </div>

              <div class="flex-between-center">
                <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin"></p>
              </div>
            </div>
          </ng-template>
        </app-auto-complete>

        <i class="far fa-times font-600 dismiss-vehicle-search pointer" (click)="handleCloseVehicleSearch()"></i>
      </div>

      <div *ngIf="isTransferVehicleEnabled && errors.transferVehicleMotorError" class="pl-4">
        <span class="font-error vin-wraaper ml-0 mb-0">
          <span class="vin-exist">{{ errors?.transferVehicleMotorError }}&nbsp;<span class="font-bold">{{
              customerList[0]?.customerName }}</span></span>
        </span>
      </div>

      <!-- Vehicle Status -->
      <div class="ui-g-12 p-0 pl-4 pr-4 mt-2 tire-storage-type">
        <div class="pointer font-14 tire-storage-section" (click)="mergeVehicleModal()">
          <i class="far fa-object-ungroup pr-1"></i>
          <span class="font-600 tire-storage">Merge</span>
        </div>
        <div *ngIf="isTireStorageEnabled" class="pointer font-14 tire-storage-section"
          (click)="openAddTireStorageModal()">
          <i class="far fa-tire pr-1"></i>
          <span class="font-600 tire-storage">Tire storage</span>
        </div>
        <div class="pointer font-14 tire-storage-section" tooltipPosition="top" [pTooltip]="'View vehicle history'"
          (click)="vehicleHistory(vehicle?._id)">
          <img class="h-15p" src="../../../../assets/img/al-logo-sm.png" />
          <span class="pl-1 font-600 tire-storage">History</span>
        </div>
        <div *ngIf="isCarfaxEnabled" class="pointer font-14 tire-storage-section" tooltipPosition="top"
          [pTooltip]="vehicle?.licensePlateNo || vehicle?.vin ? '' : 'Link using VIN or License plate to see Vehicle history'"
          [ngClass]="{ 'not-allowed': !vehicle?.licensePlateNo && !vehicle?.vin }" (click)="showVehicleHistory()">
          <img class="h-15p" src="../../../../assets/img/carfax-logo-green.svg" />
          <span class="pl-1 font-600 tire-storage">Carfax history</span>
        </div>
      </div>

      <div class="ui-g-12 ml-4 mt-2 vehicle-transfer-detail" *ngIf="isValidTransferActive()">
        <div class="d-flex">
          <i class="far fa-exclamation-triangle"></i>
          <div class="transfer-detail">Vehicle was transferred to {{ vehicle?.transferDetails?.customerName }} on {{
            vehicle?.transferDetails?.vehicleTransferDate }}</div>
        </div>
        <div class="transfer-vehicle" (click)="handleTransferVehicle()">
          <span [ngClass]="{ 'pr-2': isTransferringVehicle }">Transfer vehicle</span>
          <i *ngIf="isTransferringVehicle" class="fal fa-spinner rotate font-16"></i>
        </div>
      </div>

      <div class="ui-g-12 p-0 pl-4 pr-4 mt-3 mb-2 flex-between-center">
        <div>
          <span class="font-bold font-12 font-gray-35">Vehicle Details</span>
        </div>
      </div>

      <!-- Vehicle Year -->
      <div class="ui-g-3 p-0 pl-4 pr-2 mt-4">
        <app-input id="vehicle-update-year{{ index }}" type="text" theme="primary" placeholder="Year *" [fontSize]="14"
          [autoFocus]="highLightedVehicleId === vehicle?._id" [disabled]="disabled.year" [floatingLabel]="true"
          [value]="vehicle?.year" [isInvalid]="errors?.vehicle" [mask]="'0000'" [errorMessage]="errors?.year"
          (appChange)="handleChange('year', $event)" (appFocus)="handleFocus('year')">
        </app-input>
      </div>

      <!-- Vehicle Make -->
      <div class="ui-g-3 p-0 pl-2 pr-2 mt-4">
        <app-input id="vehicle-update-make{{ index }}" type="text" theme="primary" placeholder="Make" [maxLength]="35"
          [disabled]="disabled.make" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.make"
          [isInvalid]="errors?.make" [errorMessage]="errors?.make" (appChange)="handleChange('make', $event)">
        </app-input>
      </div>

      <!-- Vehicle Model -->
      <div class="ui-g-6 p-0 pl-2 pr-4 mt-4">
        <app-input id="vehicle-update-model{{ index }}" type="text" theme="primary" placeholder="Model"
          [disabled]="disabled.model" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.model" [maxLength]="35"
          [isInvalid]="errors?.model" [errorMessage]="errors?.model" (appChange)="handleChange('model', $event)">
        </app-input>
      </div>

      <div class="ui-g-12 p-0 pl-4 pr-4">
        <!-- Fleet Vehicle Name -->
        <div class="ui-g-6 p-0 pr-2 mt-4 position-relative vehicle-name-expose">
          <app-input id="vehicle-fleet-name{{ index }}" type="text" theme="primary" styleClassLabel="font-11"
            placeholder="Vehicle name (exposed to customers)*" [disabled]="disabled?.vehicleName" [fontSize]="14"
            [maxLength]="60" [floatingLabel]="true" [value]="vehicle?.vehicleName" [isInvalid]="errors?.vehicleName"
            [errorMessage]="errors?.vehicleName" (appFocus)="handleFocus('vehicleName')"
            (appBlur)="handleBlur('vehicleName')" (appChange)="handleChange('vehicleName', $event)">
          </app-input>

          <i class="fal fa-info-circle text-dark vehicle-name-tooltip" pTooltip="Custom vehicle name is searchable."
            tooltipPosition="top"></i>
        </div>

        <!-- Vehicle VIN -->
        <div class="ui-g-6 p-0 pl-2 mt-4 position-relative" [hidden]="!vinInputVisible">
          <app-input id="vehicle-update-vin{{ index }}" type="text" theme="primary" placeholder="VIN"
            [autoFocus]="focus?.vin" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.vin"
            [disabled]="disabled.vin || isValidTransferActive()"
            [isInvalid]="!isTransferVehicleEnabled ? errors?.vin : errors?.transferVehicleError" [maxLength]="17"
            [errorMessage]="!isTransferVehicleEnabled ? errors?.vin : ''" (appFocus)="handleFocus('vin')"
            (appClear)="onClearVIN()" buttonLabel="Transfer"
            [hasShowButton]="isValidTransferActive() || vehicle?.isTransferButtonEnabled"
            styleClassButton="transfer-vehicle-option" (appClickOutside)="handleBlur('vin')"
            (appChange)="handleChange('vin', $event)" [autoFocus]="vinInputVisible"
            (handleButton)="handleTransferVehicle()">
          </app-input>

          <button class="transfer-vehicle-option clipboard" [ngClass]="{ 'no-border': !isValidTransferActive() }"
            *ngIf="vehicle?.vin" (click)="copyVin(vehicle?.vin)" tooltipPosition="top"
            tooltipStyleClass="text-center font-11" [pTooltip]="'Copy VIN'">
            <i class="far fa-copy font-secondary-800"></i>
          </button>
          <span *ngIf="errors?.vin && vehicleAlreadyAdded && !isTransferVehicleEnabled" class="font-error vin-wraaper">
            <span class="vin-exist">{{ vinExsistErrMsg }}</span>
            <i class="fal fa-arrow-circle-right pl-1"></i>
          </span>

          <span *ngIf="errors?.transferVehicleError" class="font-error vin-wraaper ml-0">
            <span class="vin-exist">{{ errors?.transferVehicleError }}&nbsp;<span class="font-bold">{{
                customerList[0]?.customerName }}</span></span>
          </span>
        </div>

        <!-- Highlighted Vehicle VIN -->
        <div class="ui-g-6 p-0 pl-2 mt-4" [hidden]="vinInputVisible" (click)="onFocusTitle()">
          <div class="block-vin-wrapper position-relative" [hidden]="vinInputVisible" (click)="onFocusTitle()">
            <div class="block-vin-heading">VIN</div>
            <!-- <div [ngClass]="isValidTransferActive() && 'flex-between-center'"> -->
            <div class="flex-between-center">
              <div class="vin-number flex-start-center" [innerHTML]="vehicle?.vin | highlightVin"></div>
              <div class="flex-center-center">
                <button class="transfer-vehicle-option" *ngIf="vehicle?.vin" (click)="copyVin(vehicle?.vin)"
                  tooltipPosition="top" tooltipStyleClass="text-center font-11" [pTooltip]="'Copy VIN'">
                  <i class="far fa-copy font-secondary-800"></i>
                </button>
                <button class="transfer-vehicle-option" *ngIf="isValidTransferActive()"
                  (click)="handleTransferVehicle()">Transfer</button>
              </div>
            </div>
            <span *ngIf="errors?.transferVehicleError" class="font-error vin-wraaper ml-0">
              <span class="vin-exist">{{ errors?.transferVehicleError }}&nbsp;<span class="font-bold">{{
                  customerList[0]?.customerName }}</span></span>
            </span>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0 pl-4 pr-4" *ngIf="isMyFleetCenterEnabled && customer?.isFleetCustomer">
        <!-- Fleet Vehicle Name -->
        <div class="ui-g-6 p-0 pr-2 mt-4 position-relative vehicle-name-expose">
          <app-dropdown id="vehicle-driver" placeholder="Assign driver" theme="primary" field="fullName" [fontSize]="14"
            [value]="vehicle?.driver" [listItemFontSize]="13" [floatingLabel]="true" [options]="drivers"
            [isDropdownIconVisible]="true" (appSelect)="onVehicleDriverSelect($event)">
          </app-dropdown>
        </div>

        <!-- Vehicle VIN -->
        <div class="ui-g-6 p-0 pl-2 mt-4 position-relative">
          <app-input id="unit-number" type="text" theme="primary" placeholder="Unit number" [fontSize]="14"
            [floatingLabel]="true" [value]="vehicle?.unitNumber" (appChange)="handleChange('unitNumber', $event)">
          </app-input>
        </div>
      </div>

      <!-- Vehicle License Plate -->
      <div class="ui-g-6 p-0 pl-4 pr-2 mt-4">
        <app-input id="vehicle-update-license-no{{ index }}" type="text" theme="primary"
          [placeholder]="fieldPlaceholder.licensePlate" [label]="fieldPlaceholder.licensePlate" [fontSize]="14"
          [floatingLabel]="true" [value]="vehicle?.licensePlateNo" [disabled]="disabled.licensePlateNo"
          [isInvalid]="errors?.licensePlateNo" [errorMessage]="vehicleAlreadyAdded? '' : errors?.licensePlateNo"
          [errorMessage]="errors?.licensePlateNo" [maxLength]="10" [autoFocus]="licenseInputVisible"
          (appChange)="handleChange('licensePlateNo', $event)">
        </app-input>
        <span *ngIf="errors?.licensePlateNo && vehicleAlreadyAdded" class="font-error licence-wraaper">
          <span class=""> {{ lincencePlateErrMsg }} </span>
          <i class="fal fa-arrow-circle-right pl-1"></i>
        </span>
      </div>

      <!-- Vehicle Registration State -->
      <div class="ui-g-6 p-0 pl-2 pr-2 mt-4">
        <app-auto-complete id="v-registration-state" listId="v-registration-state-list" [autoFocus]="focus?.state"
          [isLoading]="isStateSearching" [placeholder]="fieldPlaceholder.regState" [label]="fieldPlaceholder.regState"
          theme="inline" scrollHeight="160px" [value]="vehicle.registrationState" [disabled]="disabled.state"
          [suggestions]="stateResults" [isInvalid]="errors?.registrationState"
          [errorMessage]="errors?.registrationState" [floatingLabel]="true" [fontSize]="14" [closeOnSelection]="true"
          (appSelect)="onStateSelect($event)" (appBlur)="handleBlur('state')" (appClickOutside)="focus.state = false"
          (appCompletedMethod)="onStateSearch($event)" (appClear)="onClear()">
          <ng-template let-item appTemplate="item">
            <div class="flex-between-center">
              <div class="font-14">{{ item.stateCode }} - {{ item?.state }}</div>
            </div>
          </ng-template>
        </app-auto-complete>
      </div>

      <div [@toggleBox]="isOpen ? 'open' : 'closed'">
        <span [hidden]="!isOpen">
          <!-- Vehicle Mileage -->
          <!-- ui-g-4 p-0 pl-2 pr-2 mt-4  -->
          <div class="ui-g-4 p-0 pl-4 pr-2 mt-4 position-relative">
            <app-input id="vehicle-update-mileage{{ index }}" type="text" theme="primary" placeholder="Mileage"
              mask="0000000000" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.mileage"
              [isInvalid]="errors?.mileage" [errorMessage]="errors?.mileage" [autoFocus]="focus?.miles"
              (appChange)="handleChange('mileage', $event)" (appFocus)="handleFocus('miles')"
              (appBlur)="handleBlur('miles')">
            </app-input>
            <i class="fal fa-info-circle text-dark vehicle-name-tooltip"
              tooltipStyleClass="ticket-tooltip modifier vehicle-tooltip side" tooltipPosition="top"
              [pTooltip]="showMileageHistory()" [escape]="false"></i>
          </div>

          <!-- Vehicle Mileage Unit -->
          <!-- ui-g-4 p-0 pl-2 pr-4 mt-4  -->
          <div class="ui-g-4 p-0 pl-2 pr-2 mt-4">
            <app-dropdown id="d-mileageUnits{{ index }}" listId="d-mileageUnits-list{{ index }}" placeholder="Units"
              theme="primary" field="label" [fontSize]="14" [value]="vehicle?.mileageMeasuringUnit"
              [listItemFontSize]="13" [floatingLabel]="true" [options]="mileageUnits" [isDropdownIconVisible]="true"
              (appSelect)="onMileageUnitSelect($event)">
            </app-dropdown>
          </div>

          <!-- Vehicle Transmission -->
          <div class="ui-g-4 p-0 pl-2 pr-2 mt-4">
            <app-dropdown id="d-vehicle-update-transmission{{ index }}"
              listId="d-vehicle-update-transmission-list{{ index }}" placeholder="Transmission" theme="primary"
              field="label" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true" [options]="transmissions"
              [value]="this.vehicle?.transmission" [isDropdownIconVisible]="true"
              (appSelect)="onTransmissionSelect($event)">
            </app-dropdown>
          </div>

          <!-- Vehicle Engine -->
          <div class="ui-g-4 p-0 pl-4 pr-2 mt-4">
            <app-input id="vehicle-update-engine{{ index }}" type="text" theme="primary" placeholder="Engine"
              [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.engine" [disabled]="disabled.engine"
              [isInvalid]="errors?.engine" [maxLength]="35" [errorMessage]="errors?.engine" tooltipPosition="top"
              [pTooltip]="vehicle?.engine" tooltipStyleClass="motor-vehicle-link-tooltip font-11"
              (appChange)="handleChange('engine', $event)">
            </app-input>
          </div>

          <!-- Vehicle Driver Type -->
          <div class="ui-g-4 p-0 pl-2 pr-2 mt-4 drive-type">
            <app-auto-complete id="ac-vehicle-update-drivetype{{ index }}"
              listId="ac-vehicle-update-drivetype-list{{ index }}" placeholder="Drive type" label="Drive type"
              theme="primary" field="name" editableItemIdKey="_id" editFieldLabel="Create drive type"
              editFieldPlaceholder="Enter drive type" scrollHeight="146px" [fontSize]="14" [hasEditableField]="true"
              [suggestions]="driverTypeSuggestions" [value]="vehicle?.driveType?.name" [floatingLabel]="true"
              [hasFutureSelectionField]="false" (appSelect)="onDriverTypeSelect($event)" [maxLength]="35"
              (appCompletedMethod)="onSearchDriverType($event)" (appClickInput)="handleFocus('driverType')"
              (appClickOutside)="handleBlur('driverType')" (appChange)="handleChange('driverType', $event)"
              (appClear)="onSuggestionsClear('driverType')" (appSave)="onCreateDriverType($event)"
              (appUpdateItem)="onDriveTypeUpdate($event, 'drive_type')">
              <ng-template let-item let-editItem="editItem" appTemplate="item">
                <div class="tag-item flex-between-center">
                  <div>
                    <span>{{ item?.name }}</span>
                  </div>
                  <div class="tag-item-action flex-end-center">
                    <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>

          <!-- Vehicle Color -->
          <div class="ui-g-4 p-0 pl-2 pr-4 mt-4 vehicle-color">
            <app-auto-complete id="ac-vehicle-update-color{{ index }}" listId="ac-vehicle-update-color-list{{ index }}"
              placeholder="Search color" label="Color" theme="primary" field="name" editFieldLabel="Create new color"
              scrollHeight="146px" editFieldPlaceholder="Enter new color" [value]="vehicle?.color?.name"
              editableItemIdKey="_id" [hasEditableField]="true" [fontSize]="14" [suggestions]="vehicleColorsSuggestions"
              [floatingLabel]="true" [hasColorSelection]="false" [hasFutureSelectionField]="false"
              (appSelect)="onVehicleColorSelect($event)" (appCompletedMethod)="onSearchVehicleColor($event)"
              (appClickInput)="handleFocus('color')" (appClickOutside)="handleBlur('color')"
              (appChange)="handleChange('color', $event)" (appClear)="onSuggestionsClear('color')"
              (appSave)="onVehicleColorCreate($event)" (appUpdateItem)="onColorUpdate($event, 'vehicle_color')">
              <ng-template let-item let-editItem="editItem" appTemplate="item">
                <div class="tag-item flex-between-center">
                  <div>
                    <span>{{ item?.name }}</span>
                  </div>
                  <div class="tag-item-action flex-end-center">
                    <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>

          <!-- Vehicle Notes -->
          <div class="ui-g-12 p-0 pl-4 pr-4 mt-4">
            <div class="">
              <app-textarea *ngIf="isOpen" placeholder="Notes" styleClassInput="pl-0" styleClass="pl-0"
                [textAreaId]="vehicle?._id + customerId" [maxLength]="2000" [selectTextOnFocus]="true" [rows]="1"
                [autoGrow]="true" [maxAutoGrowHeight]="110" [theme]="focus?.notes ? 'primary' : 'light'" [fontSize]="14"
                [value]="vehicle?.notes" [autoFocus]="focus.notes" (appChange)="handleChange('notes', $event)"
                (appFocus)="handleFocus('notes')" (appBlur)="handleBlur('notes')">
              </app-textarea>
            </div>
          </div>

          <div class="ui-g-12 p-0 pl-4 pr-4 mt-4">
            <app-tags-list buttonId="vehicle-add-tags" addTagTitle="Add tags" type="vehicle" [tags]="vehicleTags"
              [selectedTags]="vehicle?.tags" [fontSize]="11" [hasCreateOption]="true" [isDeleteable]="true"
              (appSelect)="onTagSelect($event)" (appDelete)="onTagDelete($event)" (appCreateTag)="onTagCreate($event)"
              (appUpdateTag)="updateVehicleTags($event)" (appUpdateTagList)="deleteVehicleTags($event)" (appTagDeleted)="handleTagDelete($event)">
            </app-tags-list>
          </div>
        </span>
      </div>

      <div class="ui-g-12 p-0 pl-4 pr-4 mt-2 pt-1 pb-4 flex-between-center">
        <div id="vehicle-update-show-more{{ index }}" class="show-more pointer width-100p font-600" (click)="toggle()">
          <span [hidden]="isOpen"> Show More <i class="fal fa-angle-down icon mr-1"></i></span>
          <span [hidden]="!isOpen"> Show Less <i class="fal fa-angle-up icon mr-1"></i></span>
        </div>

        <button id="vehicle-update-btn-save{{ index }}" type="button" [disabled]="isSavingVehicle" (click)="onSubmit()"
          class="btn btn-primary btn-submit btn-save-vehicle flex-start-center">
          <span [ngClass]="{ 'pr-2': isSavingVehicle }" class="font-600">Save</span>
          <i *ngIf="isSavingVehicle" class="fal fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
</div>
